/* section-tabs.js */
(function () {
  function initTabs(section) {
    const tabs = section.querySelectorAll('[data-tab-btn]');
    const panels = section.querySelectorAll('[data-tab-panel]');
    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((panel, i) => {
        panel.setAttribute('aria-hidden', String(i !== index));
      });
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { activate((i + 1) % tabs.length); tabs[(i + 1) % tabs.length].focus(); }
        if (e.key === 'ArrowLeft')  { activate((i - 1 + tabs.length) % tabs.length); tabs[(i - 1 + tabs.length) % tabs.length].focus(); }
        if (e.key === 'Home') { activate(0); tabs[0].focus(); }
        if (e.key === 'End')  { activate(tabs.length - 1); tabs[tabs.length - 1].focus(); }
      });
    });
  }

  document.querySelectorAll('[data-tabs-section]').forEach(initTabs);

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-tabs-section]');
    if (el) initTabs(el);
  });
})();
